/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import "./header.scss"
import { navLinks } from "../utils/index"

const Header = ({ siteTitle }) => (
  <header className="navbar">
    <Link className="mainPageLink" to="/" aria-label="Link do strony  głownej">
      {siteTitle}
    </Link>
    <div className="headerLinks">
      {navLinks.map(({ name, link, outlined, custom, component }) =>
        custom ? (
          component()
        ) : (
          <Link
            key={link}
            className={`link ${outlined ? "link-highlight" : ""}`}
            to={link}
            aria-label={`Link do podstrony ${name}`}
          >
            {name}
          </Link>
        )
      )}
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
